/**
 * router/index.js - Vue Router 配置
 * 功能：定义应用路由表，配置路由守卫（登录校验、初始密码强制修改）
 * 主要依赖：vue-router, vuex store
 */

import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

// 路由表配置
const routes = [
  {
    path: '/login',
    name: '登录',
    component: () => import('../views/Login.vue'),
    meta: { public: true } // 公开路由，无需登录
  },
  {
    path: '/change-password',
    name: '修改密码',
    component: () => import('../views/ChangePassword.vue'),
    meta: { public: true } // 公开路由，用于首次登录修改密码
  },
  {
    path: '/',
    component: () => import('../layout/index.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', name: '需求管理看板', component: () => import('../views/Dashboard.vue') },
      { path: 'users', name: '用户管理', component: () => import('../views/Users.vue') },
      { path: 'companies', name: '公司管理', component: () => import('../views/Companies.vue') },
      { path: 'jobs', name: '招聘需求', component: () => import('../views/JobForm.vue'), meta: { hideTopbar: true } },
      { path: 'jobs/:id/edit', name: '编辑招聘需求', component: () => import('../views/JobForm.vue'), meta: { hideTopbar: true } },
      { path: 'jobs/:id', name: '招聘需求详情', component: () => import('../views/JobDetail.vue') },
      { path: 'automation/:jobId', name: '招聘自动化', component: () => import('../views/Automation.vue') },
      { path: 'resumes', name: '简历管理', component: () => import('../views/Resumes.vue') },
      { path: 'screening/:jobId', name: '筛选结果', component: () => import('../views/Screening.vue') },
      { path: 'deliveries/:jobId', name: '交付记录', component: () => import('../views/Deliveries.vue') },
      { path: 'settings', name: '系统设置', component: () => import('../views/Settings.vue') }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

/**
 * 全局前置守卫：登录校验与初始密码强制跳转
 * 逻辑：
 * 1. 公开路由（public）允许直接访问，但已登录用户访问 /login 时自动跳转
 * 2. 非公开路由必须携带有效 token
 * 3. 使用初始密码的用户必须先到 /change-password 修改密码
 */
router.beforeEach((to, from, next) => {
  const token = store.state.auth.token
  const isInitialPassword = store.state.auth.user?.isInitialPassword

  if (to.meta?.public) {
    if (token && to.path === '/login') {
      if (isInitialPassword) {
        next('/change-password')
      } else {
        next('/dashboard')
      }
    } else {
      next()
    }
    return
  }

  if (!token) {
    next('/login')
    return
  }

  if (isInitialPassword && to.path !== '/change-password') {
    next('/change-password')
    return
  }

  next()
})

export default router
